export const AVAILABLE_BOARD_ADMINS_API_URI =
	'/rest/greenhopper/1.0/rapidviewconfig/boardadminspicker?maxResults=20';
export const UPDATE_BOARD_ADMINS_API_URI = '/rest/greenhopper/1.0/rapidviewconfig/boardadmins';

export const FETCH_USER_API_URI = '/rest/api/2/user';

export const FETCH_MY_PERIMISSIONS_API_URI = '/rest/api/2/mypermissions';
